import React from "react";
import { Badge } from "antd";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import { Link } from "react-router";
import { useGetSafetyPendingCountQuery } from "@services/safetyApi";

const SafetyAlertsButton: React.FC = () => {
  const { data } = useGetSafetyPendingCountQuery();
  const count = data?.data?.count ?? 0;

  return (
    <Link
      to="/safety"
      className="relative flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 lg:h-11 lg:w-11"
      aria-label={`Safety Alerts${count > 0 ? ` (${count} pending)` : ""}`}
    >
      <Badge
        count={count}
        size="small"
        offset={[-2, 2]}
        overflowCount={99}
        color="#0156d2"
        className="[&_.ant-badge-count]:!bg-[#0156d2] [&_.ant-badge-count]:!text-white [&_.ant-scroll-number]:!text-white"
      >
        <SafetyCertificateOutlined className="text-lg !text-white" />
      </Badge>
    </Link>
  );
};

export default SafetyAlertsButton;
